import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as globals from '@reusable/services/globals';
import { Observable } from 'rxjs';

@Injectable()
export class TeamCoreManufacturesService {
  responseData: any;

  constructor(private httpClient: HttpClient, private gtn: globals.GetTokenNow) {}

  listManufactures(sort, records, pageNumber, queries?): Observable<any> {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient
      .get(`${globals.domain}/core/manufactures/list/sortBy-${sort}/${records}/${pageNumber}/`, updateQueries)
      .pipe(map(res => res as any));
  }

  viewManufacture(manufactureId) {
    return this.httpClient.get(`${globals.domain}/core/manufactures/${manufactureId}/view`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  updateManufacture(manufactureId, body) {
    return this.httpClient
      .put(`${globals.domain}/core/manufactures/${manufactureId}/update/`, JSON.stringify(body), this.gtn.getHeaders())
      .pipe(map(res => res as any));
  }
  rearrangeManufacture(body) {
    return this.httpClient.put(`${globals.domain}/core/manufactures/rearrange`, JSON.stringify(body), this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  editManufacture(manufactureId) {
    return this.httpClient.get(`${globals.domain}/core/manufactures/${manufactureId}/edit/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  addManufacture(body) {
    return this.httpClient.post(`${globals.domain}/core/manufactures/add/`, JSON.stringify(body), this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  removeManufacture(manufactureId) {
    return this.httpClient.delete(`${globals.domain}/core/manufactures/${manufactureId}/remove/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  restoreManufacture(manufactureId) {
    return this.httpClient.put(`${globals.domain}/core/manufactures/${manufactureId}/restore/`, {}, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
}